document.addEventListener('DOMContentLoaded', () => {
    // Vérifier si on est sur la page d'accueil et cibler le Hero Video
    const heroSection = document.querySelector('.hero-video'); // Ajoutez ici la classe ou l'ID spécifique de votre Hero Video
    if (!heroSection) return; // Si la section n'existe pas, ne rien faire

    const target = document.querySelector('.hero-video h2'); // Sélectionne l'élément h2 dans Hero Video
    const baseText = "Un grain de "; // Texte fixe
    const words = ["changement", "durabilité", "souvenir"]; // Mots dynamiques
    let index = 0; // Index initial
    let deleting = false; // Indicateur de suppression
    let currentText = ""; // Texte actuel

    function animate() {
        if (!deleting) {
            // Ajouter les lettres une par une
            currentText = words[index].slice(0, currentText.length + 1);
            target.textContent = baseText + currentText;

            if (currentText === words[index]) {
                // Pause après avoir fini d'écrire un mot
                setTimeout(() => (deleting = true), 1500); // Pause prolongée avant d'effacer
            }
        } else {
            // Supprimer les lettres une par une
            currentText = words[index].slice(0, currentText.length - 1);
            target.textContent = baseText + currentText;

            if (currentText === "") {
                // Passer au mot suivant
                deleting = false;
                index = (index + 1) % words.length; // Passer au mot suivant
            }
        }

        // Ajuster les vitesses d'écriture et d'effacement
        setTimeout(animate, deleting ? 100 : 200); // Borrado plus rapide, écriture plus lente
    }

    animate(); // Lancer l'animation
});
